import lodashGet from 'lodash/get'
import lodashSet from 'lodash/set'
import lodashCloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import deLocale from 'moment/dist/locale/de'
import {v4 as uuid} from "uuid";

export default defineNuxtPlugin(() => {

    const {$i18n} = useNuxtApp();
    moment.updateLocale('de', deLocale)

    return {
        provide: {
            log: (string) => {
                console.log(string)
            },
            df: (date, format = null) => {
                return $i18n.d((date?.toDate && date?.toDate()) ?? date, format)
            },
            moment: moment,
            get: lodashGet,
            set: lodashSet,
            cloneDeep: lodashCloneDeep,
            uuid: uuid,
            getCookie: (cookieName) => {
                let b = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
                return b ? b.pop() : '';
            },
            roundCommercially: (number) => {
                if (!number || (typeof number !== "string" && typeof number !== "number")) return number
                if (typeof number === "string") number = parseFloat(number)
                if (!number) return 0
                return (Math.round((number + (Number.EPSILON * Math.sign(number))) * 100) / 100)
            }
        }
    };
})